import React from 'react';

const Shimmer = () => {
    return (
        <div className='text-white'>
            Shimmer
        </div>
    );
}

export default Shimmer;
